import Vue from "vue";
import Vuex from "vuex";
import i18n from "../i18n";

// Import store modules
import notification from "./modules/notification";
import auth from "./modules/auth";
import profile from "./modules/profile";
import category from "./modules/category";
import courses from "./modules/courses";
import cart from "./modules/cart";
import news from "./modules/news";
import billing from "./modules/billing";
import wishlist from "./modules/wishlist";
import contact from "./modules/contact";
import attestation from "./modules/attestation";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: localStorage.getItem("cl") || "lat2cyr",
    supportedLanguages: ["lat2cyr", "russian"],
  },

  mutations: {
    setLang(state, lang) {
      if (state.supportedLanguages.includes(lang)) {
        state.lang = lang;
        localStorage.setItem("cl", lang);
        i18n.locale = lang;
      }
    },
  },

  actions: {
    putLang({ commit }, lang) {
      commit("setLang", lang);
    },
  },

  getters: {
    lang: (state) => state.lang,
    supportedLanguages: (state) => state.supportedLanguages,
  },

  modules: {
    notification,
    auth,
    profile,
    category,
    courses,
    cart,
    news,
    billing,
    wishlist,
    contact,
    attestation,
  },
});
